export default __webpack_public_path__ + "static/media/asignarIconosbarra-01.02ba89b8.png";